import { createSelector } from "@reduxjs/toolkit";

export const CATEGORIES = {
  ALL_STUDENTS: { id: 1, name: "All Students" },
  // STARRED: { id: 2, name: "Starred" },
  // ACTION_REQUIRED: { id: 3, name: "Action required" },
};

export const MODES = {
  NONE: 0,
  CREATE: 1,
  EDIT: 2,
};

export const SEARCH_DELAY = 500;
export const MAX_GROUP_SIZE = 20;
export const MAX_CHARS_GROUP_NAME = 50;

export const GROUP_STATE_ROOT_SELECTOR = state => state.studentGroup;
export const CREATE_GROUP_SELECTOR = (s) => createSelector(GROUP_STATE_ROOT_SELECTOR, s);

export const USERS_ENDPOINT = "users/";
export const GROUPS = "/student_groups/";

/* error messages */
export const ErrorMsgs = {
  EMPTY_GROUP_MSG: "The group must consist of at least one student",
  EMPTY_NAME: "The group must have a name",
  MAX_GROUP_NAME_LENGTH: "The group's name is limited to 50 characters",
  GROUP_NAME_TAKEN: "Another group is using that name",
  MAX_GROUP_SIZE: "There is a maximum of 20 students per group",
  CONNECTION_PROBLEM: "Temporary issues prevented saving the group. Please try again.",
  NO_CHANGE_DETECTED: "No changes were made",
};
